import React, { useState, useEffect } from "react";
import axios from 'axios';
import { Table, Button, Tag } from 'antd';
import { BulbFilled } from '@ant-design/icons';
import Loader from '../util/Loader';
import './Main.css';
import TopNav from './TopNav';
import MainNav from './MainNav';
import StarsSharpIcon from '@material-ui/icons/StarsSharp';
import PopupComponent from "../util/FrequencyPopup";
import LoginCheck from '../util/LoginCheck';
import DecodeData from '../util/DecodeData';
import LoginFail from '../util/LoginFail';
import SelectCenter from "../util/SelectCenter";
import Filter from '../util/Filter';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';
import setup from '../setup';

let clear = false;
let name = '';
let phone = '';

let filterMode = {
    name : true,
    phone : true
}

let storage = {
    nameKeyword : '',
    phoneKeyword : '',
    popupMode : '',
    popupData : {}
}

function Frequency() {
    const [showPopup, setShowPopup] = useState(false);
    const [selectedCenter, setSelectedCenter ] = useState('');
    const [dataSource, setDataSource] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const data = useSelector(state => state.data);
    const dispatch = useDispatch();
    
    const columns = [
        {
            title : '센터명',
            dataIndex : 'cname',
            key : 'cname'
        },
        {
            title : '이름',
            dataIndex : 'name',
            key : 'name'
        },
        {
            title : '연락처',
            dataIndex : 'phone',
            key : 'phone'
        },
        {
            title : '수업일자',
            dataIndex : 'class_date',
            key : 'class_date',
            render : class_date => {
                return moment(class_date).format('YYYY-MM-DD')
            }
        },
        {
            title : '만료일자',
            dataIndex : 'exp_date',
            key : 'exp_date',
            render : exp_date => {
                return moment(exp_date).format('YYYY-MM-DD')
            }
        },
        {
            title : '상태',
            dataIndex : 'state',
            key : 'state',
            render : state => {
                let color = state == 0 ? '#999' : 'green';
                return (
                    <BulbFilled style={{color : color}} />
                )
            }
        },
        {
            title : '등록일',
            dataIndex : 'regdate',
            key : 'regdate',
            render : regdate => {
                return moment(regdate).format('YYYY-MM-DD HH:mm')
            }
        }
    ]

    const onClickRow = (record) => {
        return {
            onClick : () => {
                openPopup("edit", record)
            }
        }
    }
    
    function openPopup(mode, data) {
        setShowPopup(true);
        storage.popupMode = mode;
        storage.popupData = data;
    }

    function closePopup(isUpdated) {
        setShowPopup(false);
        if(isUpdated === "updated"){
            getDataSource()
        }
    }

    function handleSelectedCenter(cid){
        setSelectedCenter(cid);
    }

    function handleClear(){
        storage.nameKeyword = '';
        storage.phoneKeyword = '';
        clear = true;
        getDataSource();
    }

    function handleFilter(filterData){
        storage.nameKeyword = filterData.nameKeyword;
        storage.phoneKeyword = filterData.phoneKeyword
        getDataSource();
    }
    
    function getDataSource(){
        if(clear === true){
            name = ''
            phone = '';
        }else{
            name = storage.nameKeyword;
            phone = storage.phoneKeyword;
        }
        let temp_cid = '';
        if(data.cid !== 'root'){
            temp_cid = data.cid
        }else{
            temp_cid = selectedCenter
        }

        (async function () {
            const api_host = process.env.NODE_ENV === 'development' ? setup.development.api_host : setup.production.api_host;
            const result = await axios.post(api_host + '/hg_admin/get_frequency', {
                cid: temp_cid,
                nameKeyword : name,
                phoneKeyword : phone
            })
            setDataSource(result.data.rows);
        })();
    }

    async function main() {
        const result = await LoginCheck(data.url);
        if(result === "Y"){
            const decodeResult = await DecodeData(data.url);
            dispatch({type:'SET', name:"CID", value:decodeResult.cid});
            dispatch({type:'SET', name:"LEVEL", value:decodeResult.level});
            getDataSource();
            setInterval(()=>{setIsLoading(false)}, 300); 
        }else{
            LoginFail();
        }
    }

    useEffect(()=>{
        main();
    },[]);

    useEffect(()=>{
        if(data.cid === "root"){
            getDataSource();
        }
    },[selectedCenter]);

    if (isLoading) return (
        <main className="main-container">
        <TopNav />
        <div className="content-wrapper">
        <MainNav />
        <Loader />
        </div>
        </main>
    )

    return (
        <main className="main-container">
            <TopNav />
            <div className="content-wrapper">
            <MainNav />
            <div className="content-inner">
            <h3 style={{display : "inline-block"}}>프리퀀시 관리</h3>
            <div className="content-component">
                <div className="content-header">
                <div>
                <Button className="add-button" onClick={() => openPopup("add", {})}><StarsSharpIcon /> &nbsp; 프리퀀시 추가 </Button>
                </div>
                <SelectCenter 
                    onSelectedCenter={handleSelectedCenter}
                />
                </div>
                <div className="content-body">
                    <div className="table-header">
                        <div></div>
                        <div style={{display : "inline-flex"}}>
                        <Filter 
                            handleFilter = {handleFilter} 
                            handleClear = {handleClear}
                            mode = {filterMode}
                        />
                        </div>
                    </div>
                    <div className="table-body cursor">
                    <Table dataSource={dataSource} columns={columns} onRow={onClickRow} rowKey="seq" />
                    </div>
                </div>
            </div>
            {showPopup ? 
            <PopupComponent
                data = {storage.popupData}
                mode = {storage.popupMode}
                closePopup={closePopup}
            />
            : null
            }
            </div>
            </div>
        </main>
    )
}

export default Frequency;